import { Document, Font, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { NotoSansJP } from 'assets';
import { dayjs } from 'libs';
import { uniqueId } from 'lodash';
import { FC, ReactChild, ReactFragment, ReactPortal } from 'react';
import * as Types from 'types';

const hyphenationCallback = (word: string) => {
  // Return word syllables in an array
  const splittedWord = word.split('');
  const result = [] as string[];
  for (const l of splittedWord) {
    result.push(l, '');
  }
  return result;
};

Font.registerHyphenationCallback(hyphenationCallback);
Font.register({
  family: 'Noto Sans JP',
  src: NotoSansJP,
});

const BORDER_COLOR = '#bfbfbf';
const BORDER_STYLE = 'solid';
const COL1_WIDTH = 20;
const COLN_WIDTH = 100 - COL1_WIDTH;
Font.register({
  family: 'Noto Sans JP',
  src: NotoSansJP,
});
const renderTextSlingTool = (status: string | number) => {
  switch (status) {
    case 1:
      return '良';
    case 3:
      return '不使用';
    default:
      return '未確認';
  }
};
const styles = StyleSheet.create({
  body: {
    padding: 10,
    width: '100%',
    fontFamily: 'Noto Sans JP',
  },

  table: {
    display: 'flex',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: '20',
  },
  tableRow: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
  },
  tableCol1Header: {
    width: COL1_WIDTH + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColHeader: {
    width: COLN_WIDTH + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol1: {
    width: COL1_WIDTH + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol: {
    width: COLN_WIDTH + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 12,
    fontWeight: 500,
  },
  contentBorber: {
    margin: 5,
    fontSize: 12,
    fontWeight: 500,
    borderWidth: 1,
    padding: 10,
    textAlign: 'justify',
  },

  tableCell: {
    margin: 5,
    fontSize: 10,
    display: 'flex',
    flexDirection: 'row',
  },
  // table1
  row1widthColumn1: {
    width: '20%',
  },
  row1widthColumn2: {
    width: '30%',
  },
  row1widthColumn3: {
    width: '20%',
  },
  row1widthColumn4: {
    width: '30%',
  },
  // table 2
  table2Colrow1: {
    width: '100%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  with10: {
    width: '10%',
  },
  with15: {
    width: '15%',
  },
  with20: {
    width: '20%',
  },
  with30: {
    width: '30%',
  },
  with40: {
    width: '40%',
  },
  with45: {
    width: '45%',
  },
  with50: {
    width: '50%',
  },
  with60: {
    width: '60%',
  },
  with70: {
    width: '70%',
  },
  with80: {
    width: '80%',
  },
  with90: {
    width: '90%',
  },
  with100: {
    width: '100%',
  },
  fontWeightBold: {
    fontSize: 12,
    fontWeight: 'extrabold',
  },
});

interface TablePDFProps {
  data: any[];
  nameCooperator?: string;
  LockStatusData?: Types.GetSiteStatusLockedResponse | null;
  siteUserStatus: Types.UserStatuses[];
}

const renderTextFootingCheck = (status: number | string, disuse_check_status: number | string) => {
  if (disuse_check_status === 1) {
    return '-';
  }
  switch (status) {
    case 0:
      return '未確認';
    case 1:
      return '良';
    default:
      return '-';
  }
};

export const TablePDF: FC<TablePDFProps> = ({ data, nameCooperator, LockStatusData }) => {
  return (
    <Document>
      {data &&
        data.length > 0 &&
        data.map((dataPage, index) => (
          <Page style={styles.body} key={index + 1}>
            <View key={uniqueId()}>
              <Text style={styles.fontWeightBold}>危険予知活動表</Text>
            </View>
            <View key={uniqueId()} style={styles.table}>
              <View key={uniqueId()} style={styles.tableRow}>
                <View
                  key={uniqueId()}
                  style={{ ...styles.tableCol1Header, ...styles.row1widthColumn1 }}
                >
                  <Text style={styles.tableCellHeader}>日付</Text>
                </View>
                <View
                  key={uniqueId()}
                  style={{ ...styles.tableCol1Header, ...styles.row1widthColumn2 }}
                >
                  <Text style={styles.tableCellHeader}>{dataPage?.rkyDate}</Text>
                </View>
                <View
                  key={uniqueId()}
                  style={{ ...styles.tableCol1Header, ...styles.row1widthColumn3 }}
                >
                  <Text style={styles.tableCellHeader}>現場コード</Text>
                </View>
                <View
                  key={uniqueId()}
                  style={{ ...styles.tableCol1Header, ...styles.row1widthColumn4 }}
                >
                  <Text style={styles.tableCellHeader}>
                    {LockStatusData &&
                      LockStatusData.building_code &&
                      `${LockStatusData.building_code.split('-')[0]}-${
                        LockStatusData.building_code.split('-')[1]
                      }`}
                  </Text>
                </View>
              </View>

              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={styles.tableCol1}>
                  <Text style={styles.tableCell}>現場名</Text>
                </View>
                <View key={uniqueId()} style={styles.tableCol}>
                  <Text style={styles.tableCell}>{LockStatusData && LockStatusData.site_name}</Text>
                </View>
              </View>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={styles.tableCol1}>
                  <Text style={styles.tableCell}>工種</Text>
                </View>
                <View key={uniqueId()} style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    {dataPage?.listWorkType && dataPage?.listWorkType.join('・')}
                  </Text>
                </View>
              </View>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={styles.tableCol1}>
                  <Text style={styles.tableCell}>協力業者名</Text>
                </View>
                <View key={uniqueId()} style={styles.tableCol}>
                  <Text style={styles.tableCell}>{nameCooperator && nameCooperator}</Text>
                </View>
              </View>
            </View>
            {/*  table 2 */}

            <View key={uniqueId()} style={styles.table}>
              <View key={uniqueId()} style={styles.table2Colrow1}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with100 }}>
                  <Text style={{ ...styles.tableCellHeader, ...styles.fontWeightBold }}>
                    作業員情報
                  </Text>
                </View>
              </View>

              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with40 }}>
                  <Text style={styles.tableCell}>氏名</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with30 }}>
                  <Text style={styles.tableCell}>年齢</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with30 }}>
                  <Text style={styles.tableCell}>KY表確認</Text>
                </View>
                {/* 2025/04/30 Leading Win 匠対応一覧#17 start */}
                {/* 
								<View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                  <Text style={styles.tableCell}>体温</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                  <Text style={styles.tableCell}>最低血圧</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                  <Text style={styles.tableCell}>最高血圧</Text>
                </View> 
								*/}
                {/* 2025/04/30 Leading Win 匠対応一覧#17 end */}
              </View>

              {dataPage?.workerStatusTableData.data.map(
                (value: {
                  user_id: string;
                  ky_check: number;
                  // 2025/04/30 Leading Win 匠対応一覧#17 start
                  // blood_pressure_max: number;
                  // blood_pressure_min: number;
                  // body_temperature: number;
                  // 2025/04/30 Leading Win 匠対応一覧#17 end
                  user_name: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined;
                  worker_age: string;
                }) => (
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with40 }}>
                      <Text style={styles.tableCell}>{value?.user_name}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with30 }}>
                      <Text style={styles.tableCell}>{value?.worker_age}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with30 }}>
                      <Text style={styles.tableCell}>{value?.ky_check === 1 ? '○' : '-'}</Text>
                    </View>

                    {/* 2025/04/30 Leading Win 匠対応一覧#17 start */}
                    {/* 
										<View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                      <Text style={styles.tableCell}>{value?.body_temperature}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                      <Text style={styles.tableCell}>{value?.blood_pressure_min}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                      <Text style={styles.tableCell}>{value?.blood_pressure_max}</Text>
                    </View> 
										*/}
                    {/* 2025/04/30 Leading Win 匠対応一覧#17 end */}
                  </View>
                )
              )}
            </View>

            {/*  table 3 */}
            <View key={uniqueId()} style={styles.table}>
              <View key={uniqueId()} style={styles.table2Colrow1}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with100 }}>
                  <Text style={styles.tableCellHeader}>危険予知確認</Text>
                </View>
              </View>

              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                  <Text style={styles.tableCell}>作業内容</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                  <Text style={styles.tableCell}>危険ポイント</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                  <Text style={styles.tableCell}>ヒヤリ頻度</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                  <Text style={styles.tableCell}>発生時の リスク</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                  <Text style={styles.tableCell}>リスク 点数</Text>
                </View>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                  <Text style={styles.tableCell}>具体的な対策</Text>
                </View>
              </View>

              {dataPage?.ky?.ky_data &&
                dataPage?.ky?.ky_data.length > 0 &&
                dataPage?.ky?.ky_data.map((item: Types.KyData) => (
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCell}>{item?.item_name}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                      <Text style={styles.tableCell}>{item?.dangerpoint_content}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCell}>{item?.frequency_content}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                      <Text style={styles.tableCell}>{item?.occurrisk_content}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                      <Text style={styles.tableCell}>{item?.risk_point}</Text>
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with15 }}>
                      <Text style={styles.tableCell}>{item?.counterplan_content}</Text>
                    </View>
                  </View>
                ))}
            </View>

            {/*  table 4 */}
            <View key={uniqueId()} style={styles.table}>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with70 }}>
                  <Text style={styles.tableCellHeader}>玉掛け用治具の点検確認</Text>
                </View>
                {dataPage?.todaySlingtool?.all_items_check_status === 1 &&
                  dataPage?.todaySlingtool?.disuse_check_status === 0 && (
                    <>
                      <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with10 }}>
                        <Text style={styles.tableCellHeader}>点検者:</Text>
                      </View>
                      <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                        <Text style={styles.tableCellHeader}>
                          {dataPage?.todaySlingtool?.user_name}
                        </Text>
                      </View>
                    </>
                  )}
                {}
                {dataPage?.todaySlingtool?.all_items_check_status === 0 &&
                  dataPage?.todaySlingtool?.disuse_check_status === 0 && (
                    <>
                      <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with10 }}>
                        <Text style={styles.tableCellHeader} />
                      </View>
                      <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                        <Text style={styles.tableCellHeader} />
                      </View>
                    </>
                  )}
                {dataPage?.todaySlingtool === null && (
                  <>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with10 }}>
                      <Text style={styles.tableCellHeader} />
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCellHeader} />
                    </View>
                  </>
                )}
                {dataPage?.todaySlingtool?.all_items_check_status === 0 &&
                  dataPage?.todaySlingtool?.disuse_check_status === 1 && (
                    <>
                      <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with10 }}>
                        <Text style={styles.tableCellHeader}>点検者:</Text>
                      </View>
                      <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                        <Text style={styles.tableCellHeader}>
                          {dataPage?.todaySlingtool?.user_name}
                        </Text>
                      </View>
                    </>
                  )}
              </View>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                  <Text style={styles.tableCellHeader}>点検項目</Text>
                </View>

                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                  <Text style={styles.tableCellHeader}>点検結果</Text>
                </View>
              </View>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                  <Text style={styles.tableCellHeader}>ワイヤーロープ</Text>
                </View>

                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                  {dataPage?.todaySlingtool?.disuse_check_status === 1 && (
                    <Text style={styles.tableCellHeader}>-</Text>
                  )}
                  {dataPage?.todaySlingtool?.disuse_check_status !== 1 && (
                    <Text style={styles.tableCellHeader}>
                      {renderTextSlingTool(dataPage?.todaySlingtool?.wire_status)}
                    </Text>
                  )}
                </View>
              </View>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                  <Text style={styles.tableCellHeader}>シャックル</Text>
                </View>

                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                  {dataPage?.todaySlingtool?.disuse_check_status === 1 && (
                    <Text style={styles.tableCellHeader}>-</Text>
                  )}
                  {dataPage?.todaySlingtool?.disuse_check_status !== 1 && (
                    <Text style={styles.tableCellHeader}>
                      {renderTextSlingTool(dataPage?.todaySlingtool?.shackle_status)}
                    </Text>
                  )}
                </View>
              </View>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                  <Text style={styles.tableCellHeader}>ベルトスリング</Text>
                </View>

                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                  {dataPage?.todaySlingtool?.disuse_check_status === 1 && (
                    <Text style={styles.tableCellHeader}>-</Text>
                  )}
                  {dataPage?.todaySlingtool?.disuse_check_status !== 1 && (
                    <Text style={styles.tableCellHeader}>
                      {renderTextSlingTool(dataPage?.todaySlingtool?.belt_status)}
                    </Text>
                  )}
                </View>
              </View>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                  <Text style={styles.tableCellHeader}>クランプ</Text>
                </View>

                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                  {dataPage?.todaySlingtool?.disuse_check_status === 1 && (
                    <Text style={styles.tableCellHeader}>-</Text>
                  )}
                  {dataPage?.todaySlingtool?.disuse_check_status !== 1 && (
                    <Text style={styles.tableCellHeader}>
                      {renderTextSlingTool(dataPage?.todaySlingtool?.clamp_status)}
                    </Text>
                  )}
                </View>
              </View>
            </View>
            {/*  table 5 */}

            <View key={uniqueId()} style={styles.table}>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with50 }}>
                  <Text style={styles.tableCellHeader}>足場使用前点検表(安衛則　第567条1項）</Text>
                </View>
                {dataPage?.todayFootingCheck ? (
                  <>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with30 }}>
                      {dataPage?.todayFootingCheck?.all_items_check_status === 0 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 1 && (
                          <Text style={styles.tableCellHeader}>
                            点検者：{dataPage?.todayFootingCheck?.user_name}
                          </Text>
                        )}
                      {dataPage?.todayFootingCheck?.all_items_check_status === 1 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 0 && (
                          <Text style={styles.tableCellHeader}>
                            点検者：{dataPage?.todayFootingCheck?.user_name}
                          </Text>
                        )}
                      {dataPage?.todayFootingCheck?.all_items_check_status === 1 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 0 && (
                          <Text style={styles.tableCellHeader} />
                        )}
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with10 }}>
                      {dataPage?.todayFootingCheck?.all_items_check_status === 0 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 1 && (
                          <Text style={styles.tableCellHeader}>点検時刻</Text>
                        )}
                      {dataPage?.todayFootingCheck?.all_items_check_status === 1 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 0 && (
                          <Text style={styles.tableCellHeader}>点検時刻</Text>
                        )}
                      {dataPage?.todayFootingCheck?.all_items_check_status === 1 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 0 && (
                          <Text style={styles.tableCellHeader} />
                        )}
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with10 }}>
                      {dataPage?.todayFootingCheck?.all_items_check_status === 0 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 1 && (
                          <Text style={styles.tableCellHeader}>
                            {dayjs(dataPage?.todayFootingCheck?.updated_at).format('HH:mm')}
                          </Text>
                        )}
                      {dataPage?.todayFootingCheck?.all_items_check_status === 1 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 0 && (
                          <Text style={styles.tableCellHeader}>
                            {dayjs(dataPage?.todayFootingCheck?.updated_at).format('HH:mm')}
                          </Text>
                        )}
                      {dataPage?.todayFootingCheck?.all_items_check_status === 1 &&
                        dataPage?.todayFootingCheck?.disuse_check_status === 0 && (
                          <Text style={styles.tableCellHeader} />
                        )}
                    </View>
                  </>
                ) : (
                  <>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with30 }}>
                      <Text style={styles.tableCellHeader} />
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with10 }}>
                      <Text style={styles.tableCellHeader} />
                    </View>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with10 }}>
                      <Text style={styles.tableCellHeader} />
                    </View>
                  </>
                )}
              </View>
              <View key={uniqueId()} style={styles.tableRow}>
                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                  <Text style={styles.tableCellHeader}>点検項目</Text>
                </View>

                <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                  <Text style={styles.tableCellHeader}>点検結果</Text>
                </View>
              </View>
              {dataPage?.todayFootingCheck && (
                <>
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                      <Text style={styles.tableCellHeader}>
                        床材の損傷、取り外しはないか。躯体との離れは３００ｍｍ以下か。
                      </Text>
                    </View>

                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCellHeader}>
                        {renderTextFootingCheck(
                          dataPage?.todayFootingCheck?.all_items_check_status,
                          dataPage?.todayFootingCheck?.disuse_check_status
                        )}
                      </Text>
                    </View>
                  </View>
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                      <Text style={styles.tableCellHeader}>
                        建地、床材、手すり、中桟、昇降階段等ゆるみ無く堅固に固定されているか。
                      </Text>
                    </View>

                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCellHeader}>
                        {renderTextFootingCheck(
                          dataPage?.todayFootingCheck?.all_items_check_status,
                          dataPage?.todayFootingCheck?.disuse_check_status
                        )}
                      </Text>
                    </View>
                  </View>
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                      <Text style={styles.tableCellHeader}>
                        クランプ、番線、各所外れ止め金具等緊結材の損傷腐食ゆるみは無いか。
                      </Text>
                    </View>

                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCellHeader}>
                        {renderTextFootingCheck(
                          dataPage?.todayFootingCheck?.all_items_check_status,
                          dataPage?.todayFootingCheck?.disuse_check_status
                        )}
                      </Text>
                    </View>
                  </View>
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                      <Text style={styles.tableCellHeader}>
                        手すり・中桟等の取り外し及び脱落、腐食変形は無いか。高さは８５ｃｍ以上か。
                      </Text>
                    </View>

                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCellHeader}>
                        {renderTextFootingCheck(
                          dataPage?.todayFootingCheck?.all_items_check_status,
                          dataPage?.todayFootingCheck?.disuse_check_status
                        )}
                      </Text>
                    </View>
                  </View>
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                      <Text style={styles.tableCellHeader}>
                        建地と床材の隙間は１２cｍ未満となっているか。
                      </Text>
                    </View>

                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCellHeader}>
                        {renderTextFootingCheck(
                          dataPage?.todayFootingCheck?.all_items_check_status,
                          dataPage?.todayFootingCheck?.disuse_check_status
                        )}
                      </Text>
                    </View>
                  </View>
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                      <Text style={styles.tableCellHeader}>
                        柱脚部に沈下は無いか。正しく敷き板が設置されているか。
                      </Text>
                    </View>

                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCellHeader}>
                        {renderTextFootingCheck(
                          dataPage?.todayFootingCheck?.all_items_check_status,
                          dataPage?.todayFootingCheck?.disuse_check_status
                        )}
                      </Text>
                    </View>
                  </View>
                  <View key={uniqueId()} style={styles.tableRow}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with80 }}>
                      <Text style={styles.tableCellHeader}>
                        筋かい、控え、壁つなぎ等の取り外し、ゆるみはないか。
                      </Text>
                    </View>

                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with20 }}>
                      <Text style={styles.tableCellHeader}>
                        {renderTextFootingCheck(
                          dataPage?.todayFootingCheck?.all_items_check_status,
                          dataPage?.todayFootingCheck?.disuse_check_status
                        )}
                      </Text>
                    </View>
                  </View>
                  <View key={uniqueId()} style={{ ...styles.tableRow }}>
                    <View key={uniqueId()} style={{ ...styles.tableCol1, ...styles.with100 }}>
                      <Text style={styles.tableCellHeader}>是正内容</Text>
                      <Text style={{ ...styles.contentBorber }}>
                        {dataPage?.todayFootingCheck?.memo}
                      </Text>
                    </View>
                  </View>
                </>
              )}
            </View>
          </Page>
        ))}
    </Document>
  );
};
